import confetti from "canvas-confetti";

/**
 * Fire a celebratory confetti burst from the given DOM element (or center).
 * Uses the app's brand palette (emerald, amber, rose, sky).
 */
export const fireConfetti = (source) => {
  const palette = ["#10b981", "#fbbf24", "#f472b6", "#60a5fa", "#f97316", "#22c55e"];

  const originFromEl = (el) => {
    if (!el || !el.getBoundingClientRect) return { x: 0.5, y: 0.6 };
    const r = el.getBoundingClientRect();
    return {
      x: (r.left + r.width / 2) / window.innerWidth,
      y: (r.top + r.height / 2) / window.innerHeight,
    };
  };

  const origin = originFromEl(source);

  const fire = (particleRatio, opts) =>
    confetti({
      origin,
      zIndex: 10_000,
      colors: palette,
      disableForReducedMotion: true,
      particleCount: Math.floor(200 * particleRatio),
      ...opts,
    });

  fire(0.25, { spread: 26, startVelocity: 55 });
  fire(0.2, { spread: 60 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.9 });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
  fire(0.1, { spread: 120, startVelocity: 45 });
};

export default fireConfetti;
